export default class ConfigurationRoute{

    constructor(attrs) {
        this.get = 'configuration'
        this.getOne = 'configuration/'+attrs['table']
    }

}
